import React from 'react';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  Icon,
  Text,
} from '@eluve/components';

export const RailSection: React.FC<
  React.PropsWithChildren<{ title: string; defaultOpen?: boolean }>
> = ({ title, defaultOpen = false, children }) => {
  return (
    <Collapsible defaultOpen={defaultOpen}>
      <CollapsibleTrigger asChild>
        <button
          type="button"
          className="group flex w-full cursor-pointer items-center gap-1.5 py-3"
        >
          <Text
            size="xs"
            weight="semibold"
            color="tertiary"
            className="tracking-wider uppercase"
          >
            {title}
          </Text>
          <Icon
            name="ChevronDown"
            size="sm"
            className="text-text-tertiary transition-transform group-data-[state=open]:rotate-180"
          />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="flex flex-col gap-2.5 pb-3">{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
};
